/**
 * bottom-sheet.tsx — Hộp trượt từ đáy màn hình (kiểu menu "Thêm" / hành động của Lark Mobile): bo tròn hai góc trên,
 * thanh kéo nhỏ, chừa vùng an toàn dưới (thanh Home iPhone), cao tối đa 85% màn hình và tự cuộn bên trong.
 * Dựng trên Radix Dialog nên có sẵn khoá cuộn nền, Esc, bẫy focus, đọc được bằng trình đọc màn hình.
 */
import * as React from 'react'
import * as DialogPrimitive from '@radix-ui/react-dialog'
import { cn } from '@/lib/utils'

export const BottomSheet = DialogPrimitive.Root
export const BottomSheetClose = DialogPrimitive.Close

export const BottomSheetContent = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Content> & { title: string }
>(({ className, children, title, ...props }, ref) => (
  <DialogPrimitive.Portal>
    <DialogPrimitive.Overlay className="fixed inset-0 z-50 bg-black/40 animate-fade-in" />
    <DialogPrimitive.Content
      ref={ref}
      aria-describedby={undefined}
      // Không tự focus phần tử đầu (hiện viền focus lạ ngay khi mở); khung vẫn bẫy focus + đóng bằng Esc.
      onOpenAutoFocus={(e) => e.preventDefault()}
      className={cn(
        'fixed inset-x-0 bottom-0 z-50 flex max-h-[85dvh] flex-col rounded-t-2xl border-t bg-background shadow-2xl outline-none',
        'pb-[env(safe-area-inset-bottom)] animate-sheet-up',
        className,
      )}
      {...props}
    >
      <div className="mx-auto mt-2 h-1 w-9 shrink-0 rounded-full bg-muted-foreground/30" aria-hidden />
      <DialogPrimitive.Title className="sr-only">{title}</DialogPrimitive.Title>
      <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain">{children}</div>
    </DialogPrimitive.Content>
  </DialogPrimitive.Portal>
))
BottomSheetContent.displayName = 'BottomSheetContent'
